<template>
    <div class="page-box fix">
        <span class="total-des l">共{{pages}}页/{{total}}条</span>
        <ul class="l fix">
            <li v-for="(item, index) in pageList" :key="index" v-bind:class="{cur: current === item.val}" @click="setCurrent(item.val)">{{item.txt}}</li>
        </ul>
        <a class="page-ele next-page l" v-bind:class="{disabled: current === pages}" href="javascript: void(0)" @click="setCurrent(current + 1)">下一页</a>
    </div>
</template>

<script>
    export default {
        name: 'Page',
        props: {
            size: {
                type: Number,
                default: 10
            },
            total: {
                type: Number,
                default: 0
            },
            current: {
                type: Number,
                default: 1
            },
            pageGroup: {
                type: Number,
                default: 9
            }
        },
        computed: {
            pages () {
                return Math.ceil(this.total / this.size)
            },
            pageList () {
                let len = this.pages,
                    count = Math.floor(this.pageGroup / 2),
                    center = this.current,
                    temp = [],
                    list = []
                if(len <= this.pageGroup){
                    while(len--){
                        temp.push({
                            txt: this.pages - len,
                            val: this.pages - len
                        })
                    }
                    return temp
                }
                while (len--) {
                    temp.push(this.pages - len)
                }
                let idx = temp.indexOf(center)
                if (idx < count) {
                    center = center + count - idx
                }
                if (this.current > this.pages - count) {
                    center = this.pages - count
                }
                temp = temp.splice(center - (count - 2) - 1, this.pageGroup - 4)
                do {
                    let t = temp.shift()
                    list.push({
                        txt: t,
                        val: t
                    })
                } while (temp.length)
                if (this.pages > this.pageGroup) {
                    if (this.current > count + 1) {
                        list.unshift({txt: '...', val: list[0].val - 1})
                    } else {
                        list.unshift({txt: 2, val: 2})
                    }
                    if (this.current < this.pages - count) {
                        list.push({txt: '...', val: list[list.length - 1].val + 1})
                    } else {
                        list.push({txt: this.pages - 1, val: this.pages - 1})
                    }
                    // 添加首页和尾页
                    list.unshift({txt: 1, val: 1})
                    list.push({txt: this.pages, val: this.pages})
                }
                return list
            }
        },
        methods: {
            setCurrent (idx) {
                if (this.current !== idx && idx > 0 && idx < this.pages + 1) {
                    this.$emit('on-change', idx)
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .page-box{
        height: 25px;
        .total-des{
            line-height: 25px;
        }
        ul{
            padding-left: 22px;
            padding-right: 34px;
            li{
                float: left;
                width: 25px;
                height: 25px;
                text-align: center;
                line-height: 25px;
                cursor: pointer;
                &.cur{
                    background-color: #006ab9;
                    color: #fff;
                    pointer-events: none;
                    cursor: default;
                }
                &.no-event{
                    pointer-events: none;
                    cursor: default;
                }
            }
        }
        .next-page{
            display: block;
            width: 68px;
            height: 25px;
            background-color: #006ab9;
            color: #fff;
            text-align: center;
            line-height: 25px;
            cursor: pointer;
            &.disabled{
                background-color: #a3a3a3;
                pointer-events: none;
                cursor: default;
            }
        }
    }
</style>
